const checkDeleteCompanyCallFormService = {
  confirm: 'Deseja realmente deletar este serviço? Todas as Ações relacionadas a esse serviço serão deletadas',
  title: 'DELETAR SERVIÇO'
};

export default checkDeleteCompanyCallFormService;
